<template>
  <div class="pilot-box" :class="{ 'pilot-flex': navMax, 'pilot-loading': loading }">
    <div class="new-popupbox box-loading" v-if="loading">
      <a-spin tip="正在读取教材内容，请稍后..." size="large" wrapperClassName="box-spin" />
    </div>

    <a-empty class="empty-box" :image="simpleImage" v-if="intList.length == 0" />
    <!-- 菜单 -->
    <div class="nav-fold-box" @mouseenter="mouseEvent(false)" @click="mouseEvent(false)">
      <div class="icon-omit-box" v-if="!navMax">
        <svg class="icon-omit">
          <use xlink:href="#icon-bar" />
        </svg>
      </div>
    </div>
    <textbookNav ref="textbookNavRef" :class="{ fold: navFold, navMax: navMax }" :chapter_num="chapter_num"
      @switchChapter="switchChapter($event, 'chapter')" @mouseleave="navMouseleave()"
      @gradeChange="gradeChanging = $event" @swichNavMax="swichNavMax($event)"
      @openResourceOutline="isOpenResourceOutline = true" @scrollToOutline="jumpTargetNode($event)"
      @foldNav="foldNav($event)" @chooseChildNav="chooseChildNav($event)" @recordJump="data => returnBtnData = data">
    </textbookNav>
    <OutlineForResource v-if="isOpenResourceOutline" @close="isOpenResourceOutline = false"
      @change="isOpenResourceOutline = false; navFold = false" />
    <search :intList="intList" @jumpTargetNode="jumpTargetNode($event)" />
    <card ref="cardRef" @cardUpdated="refreshCard" />
    <noteBox :chapter_num="chapter_num" :allNote="allNote" :noteData="noteData"
      @switchChapter="switchChapter($event, 'chapter')" @chooseNote="chooseNote($event)" v-if="!loadNote"></noteBox>
    <questionBox :chapter_num="chapter_num" :allNote="allNote" :questionData="questionData"
      @chooseNote="chooseNote($event)" @refreshNote="note => refreshNote(note)" v-if="!loadNote"></questionBox>
    <pilot-achievement></pilot-achievement>

    <KnowledgeGraph_v2 :nodeIdMap="nodeIdMap" @close="closeTab()"
      @clickGraphNode="clickGraphNode" v-if="pilotNavOpen === 'knowledgeGraph'" v-show="!hidePilotNavOpen">
    </KnowledgeGraph_v2>

    <!-- 具体内容 -->
    <div class="pilot-content-box">
      <div class="pilot-content">
        <div class="int-item" :id="int.PK_InductionGuid" :class="{ 'active': int.chapter_num == chapter_num }"
          v-for="(int, index) in intList" :key="int.PK_InductionGuid">
          <TextbookRender class="textbook-item" ref="textbookRenderRef" :textbookData="int" :inductionIndex="index"
            :nodeIdMap="nodeIdMap" @noteUpdated="handleNoteUpdated()" @cardUpdated="handleCardUpdated()"
            @updateReadAnchor="data => handleUpdateReadAnchor(data)" @jumpTargetNode="jumpTargetNode($event)"
            @recordJump="data => returnBtnData = data" v-if="int.show && int.TextbookContent" />
        </div>
      </div>
      <div class="pilot-page">
        <!-- <div class="page-button" v-if="chapter_num > 0" @click="switchChapter(chapter_num - 1, 'chapter')">
          <svg class="icon-svg icon-last">
            <use xlink:href="#icon-last" />
          </svg>
          <span class="page-text">上一单元</span>
        </div> -->

        <div class="page-button" v-if="chapter_num != null && chapter_num < intList.length - 1"
          @click="switchChapter(chapter_num + 1, 'chapter')">
          <span class="page-text">{{ intList[chapter_num + 1]?.InductionName }}</span>
          <svg class="icon-svg icon-next">
            <use xlink:href="#icon-next" />
          </svg>
        </div>
      </div>
    </div>

    <div class="jump-return" v-if="returnBtnData">
      <span class="text" @click="returnToBlock()">{{ returnBtnText }}</span>
      <svg class="icon-svg popup-close" @click="returnBtnData = null">
        <use xlink:href="#icon-close" />
      </svg>
    </div>
  </div>
</template>

<script>
import { Empty } from 'ant-design-vue';
import { LoadingOutlined } from '@ant-design/icons-vue';
import { PASSPORT_CLIENT_SERVER } from '@/config/url';
import { ClassNameMap, BlockTypeMap } from '@/config/constant';

import headPath from '@/filter/headPath';
import textbookNav from '@/components/list/textbook-list/textbook-nav/textbook-nav.vue';
import OutlineForResource from '@/components/list/textbook-list/textbook-nav/OutlineForResource.vue';
import search from '@/components/list/pilot-list/search/search.vue';
import card from '@/components/list/pilot-list/card/card.vue';
import noteBox from '@/components/list/pilot-list/note-box/note-box.vue';
import questionBox from '@/components/list/pilot-list/question-box/question-box.vue';
import pilotAchievement from '@/components/list/pilot-list/pilot-achievement/pilot-achievement.vue';
import TextbookRender from '@/components/list/textbook-list/TextbookRender/index.vue';
import KnowledgeGraph_v2 from '@/components/list/KnowledgeGraph_v2.vue';

export default {
  name: 'textbook-list',
  components: {
    LoadingOutlined,
    pilotAchievement,
    search,
    card,
    noteBox,
    TextbookRender,
    questionBox,
    textbookNav,
    OutlineForResource,
    KnowledgeGraph_v2
  },
  props: {
    classInfo: Object,
    userScore: Object,
    intList: Array,
    stuList: Array,
  },
  data() {
    return {
      navFold: true,
      navMax: false,
      loading: true,
      chapter: null,
      chapter_num: null,

      userInfo: {},

      locationUrl: '',
      platform_type: '',
      classId: '',
      pilotNavOpen: '',

      allNote: [],
      noteData: [],
      questionData: [],
      knowledgeGraph: [],

      loadNote: true,
      gradeChanging: false,
      hidePilotNavOpen: false,

      needRouterNote: null,
      needRouterElement: null,

      isOpenResourceOutline: false,
      returnBtnData: null,

      nodeIdMap: [],

      simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
    }
  },
  computed: {
    returnBtnText() {
      if (!this.returnBtnData) return ''

      if (this.returnBtnData.type === 'node') return '返回跳转前的位置'
      if (this.returnBtnData.type === 'mindmap') return '返回思维导图大纲'
      if (this.returnBtnData.type === 'knowledgeGraph') return '返回知识图谱'
      return ''
    },
  },
  async mounted() {
    this.locationUrl = window.location.href;
    const { platform, userInfo, currentClass } = this.$store.state;
    this.theme_color = platform.pageConfig.theme_color;
    this.platform_type = platform.Type;
    this.userInfo = userInfo;
    this.classId = currentClass.PK_ClassGuid;

    this.loadFuction();
    this.initNodeIdMap();
  },
  methods: {
    initNodeIdMap() {
      const idMap = []
      for (const int of this.intList) {
        const item = { inductionId: int.PK_InductionGuid, idList: [] }
        const textbookContent = JSON.parse(int.TextbookContent)
        let div = document.createElement('div')
        div.innerHTML = textbookContent.content

        const nodes = div.querySelectorAll('[data-id]')
        for (const node of nodes) {
          item.idList.push(node.dataset.id)
        }
        idMap.push(item)

        div = null
      }
      this.nodeIdMap = idMap

      //获取是否需要跳转地址
      const { routerIntId, routerDataId } = this.$route.query;
      if (routerDataId) {
        let intId = routerIntId;
        idMap.find(item => {
          if (item.idList.includes(routerDataId)) {
            intId = item.inductionId
          }
        })

        setTimeout(() => {
          this.jumpTargetNode({ inductionId: intId, id: routerDataId })
          let query = { ...this.$route.query };
          delete query.routerIntId;
          delete query.routerDataId;

          this.$router.push({
            path: this.$route.path,
            query: query
          })
        }, 100);
      }
    },

    returnToBlock() {
      if (!this.returnBtnData) return

      const { type, inductionId, id } = this.returnBtnData
      if (type === 'node') {
        this.jumpTargetNode({ inductionId, id })
      }
      if (type === 'mindmap') {
        this.$refs.textbookNavRef.openMindmap(inductionId)
      }
      if (type === 'knowledgeGraph') {
        this.hidePilotNavOpen = false;
      }
      this.returnBtnData = null
    },

    async loadFuction() {
      if (this.intList.length == 0) return this.loading = false;
      this.switchChapter(0, 'chapter');

      const { isLocal } = this.$store.state;
      if (!isLocal) this.findNoteList();

      this.$store.subscribe((res) => {
        if (!res) return;
        let { type, payload } = res;

        if (type == "pilotNavOpen") {
          document.removeEventListener('click', this.handleClickOutside);
          if (payload) {
            if (payload === 'knowledgeGraph') {
              this.hidePilotNavOpen = false;
              this.returnBtnData = { type: 'knowledgeGraph' };
            }
            setTimeout(() => {
              document.addEventListener('click', this.handleClickOutside);
            }, 300);
          }
          else if (this.pilotNavOpen === 'knowledgeGraph' && !payload) {
            this.returnBtnData = null;
          }

          this.pilotNavOpen = payload;
        }
      })

      //获取知识图谱
      const kgRes = await this.$api.digitalbook.getKnowledgeGraph(this.classId);
      if (kgRes.data && kgRes.data.Content) {
        const knowledgeGraph = JSON.parse(kgRes.data.Content)
        this.knowledgeGraph = knowledgeGraph

        this.$store.commit('setKnowledgeGraph', knowledgeGraph);
      }
    },
    // 更新最后阅读位置（下一次打开后自动跳转到该位置）
    // 该位置同样用于记录阅读的进度，每次接收数据后都与当前进度做对比，比当前进度的位置更靠后的话就更新进度
    handleUpdateReadAnchor(data) {
      //console.log(data)
    },


    //笔记更新
    handleNoteUpdated() {
      this.findNoteList();
    },
    //删除修改了笔记
    refreshNote(note) {
      if (this.$refs.textbookRenderRef[0]) this.$refs.textbookRenderRef[0].deleteNote(note)
    },

    // 知识卡片更新
    handleCardUpdated() {
      this.$refs.cardRef.initData()
    },
    // 同步内容中的知识卡片
    refreshCard(payload) {
      if (payload.action === 'delete') {
        if (this.$refs.textbookRenderRef[0]) this.$refs.textbookRenderRef[0].deleteCard(payload.uid)
      }
      if (payload.action === 'update') {
        const { uid, props } = payload
        if (this.$refs.textbookRenderRef[0]) this.$refs.textbookRenderRef[0].updateCard(uid, props)
      }
    },

    //移入移出
    mouseEvent(event) {
      if (this.folding) return;
      this.folding = true;
      setTimeout(() => {
        this.folding = false;
      }, 200);

      this.navFold = event;
    },
    //移出
    navMouseleave() {
      if (this.gradeChanging) return;
      this.mouseEvent(true);
    },

    //切换章节
    switchChapter(num, type) {
      if (num < 0) return this.$message.warning('没有上一页');
      else if (num > this.intList.length - 1) return this.$message.warning('已是最后一页');
      let chapter_num = this.chapter_num;

      if (num == chapter_num) {
        if (this.needRouterNote) this.routerNote()
        else if (this.needRouterElement) this.routerElement();
        else $('.scroll-box').animate({ scrollTop: 0 })
        return
      }

      this.loading = true;
      this.chapter_num = num;

      this.$nextTick(() => {
        //是否需要加载章节
        this.loadChapter(num);

        //是否需要加载内容
        this.intList.forEach((int, i) => {
          if (i == num) {
            this.loading = false;
            if (this.needRouterNote) setTimeout(() => { this.routerNote() }, 100);
            else if (this.needRouterElement) setTimeout(() => { this.routerElement() }, 100);
            else if (type == 'chapter') $('.scroll-box').animate({ scrollTop: 0 })
          }
        })
      })
    },
    //加载前后章节
    loadChapter(num) {
      this.intList.forEach(int => { int.show = false })
      this.intList[num].show = true;
      // if (num > 0) this.intList[num - 1].show = true
      // if (num + 1 < this.intList.length) this.intList[num + 1].show = true;
    },
    //监听iframe弹窗
    listenIframeBox() {
      let that = this;
      this.$nextTick(() => {
        let iframe = that.$refs["iframeBox"];
        //发送值
        iframe.contentWindow.postMessage({
          command: 'postStudentId',
          data: {
            studentId: this.userInfo.PK_UserGuid,
          },
        }, '*')
      })
    },

    ///////////////////////////菜单
    //滚动到code
    scrollTo(id) {
      this.$nextTick(async () => {
        let that = $(`[data-push-id=${id}]`);
        if (that && that.offset()) {
          let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - 300;
          $('.scroll-box').animate({
            scrollTop
          }, 300);
          that.children('.app-view-header').click();
        }
      })
    },
    //固定菜单
    swichNavMax(event) {
      this.navMax = event;
    },
    //折叠菜单
    foldNav(event) {
      this.mouseEvent(event);
    },

    //监听菜单点击
    chooseChildNav(data) {
      const { intId, id } = data;
      this.needRouterElement = id;
      const currentInt = this.intList[this.chapter_num];
      if (intId && intId != currentInt.PK_InductionGuid) {
        const chapter_num = this.intList.findIndex(item => item.PK_InductionGuid == intId);
        if (chapter_num != null) this.switchChapter(chapter_num, 'chapter');
      }
      else this.routerElement();

    },
    //跳转段落
    routerElement() {
      if (!this.needRouterElement) return;
      let that = $(`[data-id=${this.needRouterElement}]`);
      if (that && that.offset()) {

        let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - 80;
        $('.scroll-box').animate({ scrollTop }, 300);
        this.needRouterElement = null;
      }
    },

    //判断用户是否在线
    async judgeOnline() {
      const ret = await this.$api.unifydata.verifyToken({ token: this.userInfo.token });
      if (ret.statusCode != 200) location.href = `${PASSPORT_CLIENT_SERVER}/yuanxi?redirectURI=${location.href}`;
    },
    //防抖
    debounce(fn, delay) {
      let timer;
      return function () {
        if (timer) {
          clearTimeout(timer);
        }
        timer = setTimeout(() => {
          fn();
        }, delay);
      }
    },

    //////////////////////////////////////获取笔记
    //获取note
    async findNoteList() {
      let res = await this.$api.note.findList(this.classId);
      if (res.statusCode != 200) return this.$message.warning(res.message);

      this.allNote = res.data || [];

      let noteList = [];
      let allStuList = [];
      //处理数据
      res.data.forEach(item => {
        if (allStuList.indexOf(item.fk_studentId) == -1) allStuList.push(item.fk_studentId);
        item.notes.forEach(note => {
          noteList.push({
            fk_studentId: item.fk_studentId,
            fk_trainId: item.fk_trainId,
            fk_unitId: item.fk_unitId,
            _id: item._id,
            uid: note.uid,
            type: note.type,
            text: note.text || BlockTypeMap[note.blockType],
            content: note.content,
            public: note.public,
            themeColor: ClassNameMap[note.className] || '#66666',
            bakColor: ClassNameMap[note.className] ? ClassNameMap[note.className] + 40 : '#6666640',
            noteType: note.noteType,
            updateTime: note.updateTime,
            isMine: item.fk_studentId == this.userInfo.PK_UserGuid,
            comments: note.comments || []
          })

          //找到评论学生
          if (note.comments) {
            note.comments.forEach(comment => {
              if (allStuList.indexOf(comment.studentId) == -1) allStuList.push(comment.studentId);
              comment.isMine = comment.studentId == this.userInfo.PK_UserGuid;
            })
          }
        })
      })

      //获取用户信息
      let userList = [];
      if (allStuList.length > 0) {
        let userIdList = JSON.stringify(allStuList).replace('[', '').replace(']', '');
        userList = await this.$api.note.getStudentUser(userIdList).then(res => res.data || []);
        userList.forEach(user => {
          user.name = user.NickName || user.Name;
          user.headPhotoPath = headPath(user.HeadPhotoPath);
        })
      }

      let newReply = 0;
      noteList.forEach(note => {
        let user = userList.find(item => item.PK_UserGuid == note.fk_studentId);
        if (user) {
          note.userName = user.name;
          note.headPhotoPath = user.headPhotoPath;
        }

        //匹配回复
        note.comments.forEach(comment => {
          let user = userList.find(item => item.PK_UserGuid == comment.studentId);
          if (user) {
            comment.userName = user.name;
            comment.headPhotoPath = user.headPhotoPath;

            if (comment.isNew && note.isMine && !comment.isMine) newReply += 1;
          }
        })
      })
      if (newReply > 0) this.$store.commit('newReply', newReply);

      this.noteData = noteList.filter(item => item.noteType != 'question');
      this.questionData = noteList.filter(item => item.noteType == 'question');

      this.loadNote = false;
    },
    //选择一个id
    chooseNote(note) {
      let { uid, fk_unitId, fk_trainId } = note;
      let chapter_num = null;
      this.intList.forEach((int, i) => {
        if (fk_unitId == int.PK_InductionGuid) chapter_num = i;
        else if (fk_trainId == int.PK_InductionGuid) {
          this.needRouterNote = uid;
          chapter_num = i;
        }
      })
      if (chapter_num != null) this.switchChapter(chapter_num, 'chapter');
    },
    //跳转note
    routerNote() {
      if (!this.needRouterNote) return;

      let that = $(`[data-selector=${this.needRouterNote}]`);
      if (that.length) {
        let maxHeight = $('.scroll-box').height();
        let scrollTop = $(`.scroll-box`).scrollTop() + that.offset().top - (maxHeight / 2 - 50);
        $('.scroll-box').animate({ scrollTop }, 300);
      }
      this.needRouterNote = null;
    },
    closeTab() {
      this.$store.commit('pilotNavOpen', '');
    },
    clickGraphNode(e) {
      const { inductionId, id } = e;
      let intId = inductionId;
      this.nodeIdMap.find(item => {
        if (item.idList.includes(id)) {
          intId = item.inductionId
        }
      })

      this.returnBtnData = { type: 'knowledgeGraph' };
      this.hidePilotNavOpen = true;
      this.jumpTargetNode({ inductionId: intId, id })
    },
    //监听跳转
    jumpTargetNode(data) {
      const { inductionId, id } = data;
      this.needRouterElement = id;

      const chapter_num = this.intList.findIndex(item => item.PK_InductionGuid == inductionId);
      if (chapter_num != null) {
        this.switchChapter(chapter_num, 'chapter');
      }
    },

    async handleClickOutside(event) {
      const popupElement = this.$el.querySelector('.showPopup');

      if (popupElement && !popupElement.contains(event.target)) {
        this.$store.commit('pilotNavOpen', false);
      }
    },
  },
  //组件销毁
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
}
</script>

<style scoped lang="scss">
@import "./textbook-list.scss";
</style>